// eslint-disable-next-line
import moment from "moment";

export default {
  methods: {
    formatEventDateShort(eventDateFrom) {
      const formattedDate = moment(eventDateFrom).locale("ja-JP").utc().format('M.D(ddd)');
      return formattedDate;
    },
    formatEventTime(eventDateFrom) {
      const formattedTime = moment(eventDateFrom).utc().format("HH:mm");
      return formattedTime;
    },
    formatEventDateTime(eventDateFrom, eventDateTo) {
      const formattedDate = moment(eventDateFrom).locale("ja-JP").utc().format('M/D(ddd)');
      const formattedTimeFrom = moment(eventDateFrom).utc().format('HH:mm');
      const formattedTimeTo = moment(eventDateTo).utc().format('HH:mm');
      return `${formattedDate} ${formattedTimeFrom}～${formattedTimeTo}`;
    },
    formatApplicationDeadline(deadlineDate) {
      const formattedDate = moment(deadlineDate).locale("ja-JP").utc().format('M/D(ddd)');
      const formattedTime = moment(deadlineDate).utc().format('HH:mm');
      return `${formattedDate} ${formattedTime} 締切`;
    },
    checkApplicationStatus(event) {
      if(this.profile.events.includes(event._id)) {
        return true;
      } else {
        return false;
      }
    },
    getApplicationButtonClass(event) {
      if (this.checkApplicationStatus(event)) {
        return 'applied-status';
      } else {
        return 'not-applied-status';
      }
    },
    getApplicationButtonText(event) {
      if (this.checkApplicationStatus(event)) {
        return '申込み済';
      } else {
        return '未申込み';
      }
    },
    checkIfApplied(event) {
      let specificClass = '';
      if (this.profile.events.includes(event._id)) {
        specificClass = 'applied';
      } else if (
        moment(event.application_period.to)
          .utc()
          .format() < moment(new Date()).format() ||
        event.status.title == "Closed" ||
        moment(new Date()).format() <
          moment(event.application_period.from)
            .utc()
            .format()
      ) {
        specificClass = 'closed';
      } else if (event.is_test_event) {
        specificClass = 'test';
      } else {
        specificClass = 'valid';
      }
      return `event-button ${specificClass} mb-2`;
    },
    checkApplied(id) {
      if (this.profile.events.includes(id._id)) {
        return '申込済み';
      } else if (id.status.title === 'Closed') {
        return '受付終了';
      }
      return '申込む';
    },
    checkToDisable(event) {
      if (
        moment(event.application_period.to)
          .utc()
          .format() < moment(new Date()).format() ||
          this.profile.events.includes(event._id)
      ) {
        return true;
      } else if (
        moment(new Date()).format() <
          moment(event.application_period.from)
            .utc()
            .format()
      ) {
        return true;
      } else if (event.status.title == 'Closed') {
        return true;
      }
      return false;
    },
    urlify(description) {
      const urlRegex = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi;
      return description.replace(urlRegex, (url) => {
        const checkLinkType =
            !!(url.includes('http') || url.includes('http'));
        if (checkLinkType) { return `<a href="${url}" target="_blank">${url}</a>`; }
        return (
          `<a href="https://${url}" target="_blank">${url}</a>`
        );
      });
    },
  }
};


